import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import Styles from './styles';
const SelectedDate = (props) => {
    const { onClicked, optionType, value, layout, icon, } = props;
    if (layout === 'winter-wonderland' || layout === 'horizontal' || layout === 'rework') {
        return (_jsxs(Styles.Wrapper, { type: "button", onClick: onClicked, children: [icon && _jsx(Styles.Icon, { children: icon }), _jsx(Styles.Value, { children: value }), _jsxs(Styles.DummyLink, { children: ["Change", _jsx("span", { children: ` ${optionType.toLocaleLowerCase()}` })] })] }));
    }
    return (_jsxs(Styles.Wrapper, { type: "button", onClick: onClicked, children: [_jsx(Styles.Title, { children: optionType }), _jsx(Styles.DummyLink, { children: value })] }));
};
SelectedDate.defaultProps = {
    icon: undefined,
};
export default SelectedDate;
